// The interviewer seat's routes (lane contract C-29), registered at import through ../register.ts:
//   #interviews                         Interviews, behind packet.list_mine
//   #interviews/<packet>                the interviewer packet pane
//   #interviews/<packet>/<application>  the Scorecard page
//   #interviews/debriefs                Debriefs, behind debrief.list_mine
//   #interviews/debriefs/<cycle>        the viewer's own debrief view
// The two debrief patterns also match the packet patterns' shapes, so they carry the higher specificity. A record route
// carries its own seat rule on the server; an id the viewer may not open resolves to nothing, never to another record.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { Debriefs } from "./Debriefs";
import { Interviews } from "./Interviews";
import { MyDebrief } from "./MyDebrief";
import { PacketPane } from "./PacketPane";
import { ScorecardPage } from "./ScorecardPage";

export const SCORE_ROUTES = {
  interviews: /^interviews$/,
  packet: /^interviews\/[^/]+$/,
  scorecard: /^interviews\/[^/]+\/[^/]+$/,
  debriefs: /^interviews\/debriefs$/,
  myDebrief: /^interviews\/debriefs\/[^/]+$/,
} as const;

function InterviewsRoute(_: ViewProps) {
  return createElement(Interviews);
}

function PacketRoute({ route }: ViewProps) {
  return createElement(PacketPane, { key: route.parts[0], packetId: route.parts[0] ?? "" });
}

function ScorecardRoute({ route }: ViewProps) {
  const [packetId = "", applicationId = ""] = route.parts;
  return createElement(ScorecardPage, { key: `${packetId}/${applicationId}`, packetId, applicationId });
}

function DebriefsRoute(_: ViewProps) {
  return createElement(Debriefs);
}

function MyDebriefRoute({ route }: ViewProps) {
  return createElement(MyDebrief, { key: route.parts[1], cycleId: route.parts[1] ?? "" });
}

registerView(SCORE_ROUTES.interviews, InterviewsRoute, { lane: "B7", gates: ["packet.list_mine"] });
registerView(SCORE_ROUTES.packet, PacketRoute, { lane: "B7", specificity: 1, gates: ["packet.open"] });
registerView(SCORE_ROUTES.scorecard, ScorecardRoute, { lane: "B7", specificity: 1, gates: ["scorecard.open"] });
registerView(SCORE_ROUTES.debriefs, DebriefsRoute, { lane: "B7", specificity: 2, gates: ["debrief.list_mine"] });
registerView(SCORE_ROUTES.myDebrief, MyDebriefRoute, { lane: "B7", specificity: 2, gates: ["debrief.open"] });
